import type { TenantMemberStatus } from '@/types'

interface MemberStatusBadgeProps {
  status: TenantMemberStatus
}

export function MemberStatusBadge({ status }: MemberStatusBadgeProps) {
  if (status === 'Active') {
    return (
      <span
        data-testid="member-status-badge"
        className="inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium bg-success text-success-foreground border border-success-foreground"
      >
        Active
      </span>
    )
  }
  return (
    <span
      data-testid="member-status-badge"
      className="inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium bg-warning text-warning-foreground border border-warning-foreground"
    >
      Invited
    </span>
  )
}
